import React from "react";
import CreateRatingInput from "../create/CreateRatingInput";
import RatingInput from "../create/RatingInput";
import Checkbox from "../misc/elements/Checkbox";

const UseTimeValue = ({ time, onEnable, onTimeDescription }) => {
  return (
    <div className="divColumn" style={{ width: "100%" }}>
      <UsingBar time={time} onEnable={onEnable} />
      {time != null && (
        <UsesTimeBar time={time} onTimeDescription={onTimeDescription} />
      )}
    </div>
  );
};

const UsesTimeBar = ({ time, onTimeDescription }) => {
  return (
    <div className="divRow" style={{ width: "100%" }}>
      <div className="divRow" style={{ marginTop: "10px" }}>
        <div
          className="textBoldWhite"
          style={{
            paddingLeft: "5px",
            paddingRight: "5px",
            flexDirection: "column",
            height: "26px",
            backgroundColor: "#6f6f6f",
            display: "flex",
            fontSize: "12px",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          Describe what the time stands for
        </div>
        <RatingInput
          value={time}
          onChange={onTimeDescription}
          field="hint"
          width="400px"
          hint="description"
          maxLength={100}
        />
      </div>
    </div>
  );
};

const UsingBar = ({ time, onEnable }) => {
  function onClick() {
    onEnable(time != null ? null : "");
  }
  return (
    <div
      onClick={onClick}
      className="divRow"
      style={{
        width: "30%",
        padding: "5px",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: "#8f8f8f",
        borderRadius: ".5rem/.5rem",
        border: "3px solid #2f2f2f",
      }}
    >
      <Checkbox item={time} otherItem={time == null} />
      <div className="textBoldWhite" style={{ marginLeft: "5px" }}>
        Enable Time Value
      </div>
    </div>
  );
};

export default UseTimeValue;
